// ABOUTME: Context for sharing dashboard data between Dashboard and Layout components.
// ABOUTME: Allows StatusBar in sidebar to access data fetched by Dashboard.

import React, { createContext, useContext, useState } from 'react';

const DashboardContext = createContext(null);

export function DashboardProvider({ children }) {
  const [dashboardState, setDashboardState] = useState({
    currentTime: new Date(),
    dashboardData: null,
    onReloadConfig: null,
  });

  return (
    <DashboardContext.Provider value={{ dashboardState, setDashboardState }}>
      {children}
    </DashboardContext.Provider>
  );
}

export function useDashboard() {
  const context = useContext(DashboardContext);
  if (!context) {
    throw new Error('useDashboard must be used within a DashboardProvider');
  }
  return context;
}
